import styled, { useTheme } from "styled-components";

interface AvatarProps {
  width?: string;
}

export const Avatar = ({ width = "3.438rem" }: AvatarProps) => {
  const { companyLogo } = useTheme();

  if (!companyLogo) return null;
  return <ImgContainer src={companyLogo} $width={width} />;
};

const ImgContainer = styled.img<{ $width: string }>`
  width: ${({ $width }) => $width};
  aspect-ratio: 1;
  border-radius: 1.75rem;
`;
